import Popover from './Popover';

// export types
export type { PopoverProps } from './Popover';

// export components
export { Popover };
export default Popover;
